import { render, staticRenderFns } from "./SettingsResourceimages.vue?vue&type=template&id=59c9989c&scoped=true&"
import script from "./SettingsResourceimages.vue?vue&type=script&lang=ts&"
export * from "./SettingsResourceimages.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsResourceimages.vue?vue&type=style&index=0&id=59c9989c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9989c",
  null
  
)

export default component.exports